import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=9274dd96&scoped=true"
import script from "./VideoBox.vue?vue&type=script&lang=js"
export * from "./VideoBox.vue?vue&type=script&lang=js"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=9274dd96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9274dd96",
  null
  
)

export default component.exports